import React, {useState, useEffect} from "react";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {useStore} from "../../../hooks/useStore";
import {Table, Tooltip} from "antd";
import {useFetch} from "../../../hooks/useFetch";
import moment from "moment";
import CompletedTransferDetail from "./CompletedTransferDetail";

const CompletedTransfers = () => {
    const stores = useStore();
    const [detailModal, setDetailModal] = useState(false);
    const [completedTransferDetail, setCompletedTransferDetail] = useState(null);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    const [transfersDataLoading, transfersData, _, __, refetch] = useFetch({
        fetchFn: () =>
            stores.transferStore.getTransferReference({
                status: "completed",
                page: pagination.current,
                limit: pagination.pageSize
            }),
        loading: true,
        initialCall: false
    });

    useEffect(() => {
        refetch();
    }, [pagination.current, pagination.pageSize]);

    const handleTableChange = newPagination => {
        setPagination({
            current: newPagination.current,
            pageSize: newPagination.pageSize,
            total: newPagination.total
        });
    };

    const getCompletedTransferDetail = async record => {
        try {
            setLoading(record._id);
            const response = await stores.transferStore.getTransferReference({
                id: record._id,
                status: "completed"
            });

            setSelectedRecord(record);
            setCompletedTransferDetail(response);
            setDetailModal(true);
        } catch (error) {
            console.error("Transfer detay hatası:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Table
                dataSource={transfersData?.transferReference?.data}
                style={{width: "100vw"}}
                loading={transfersDataLoading || loading}
                scroll={{y: "calc(100vh - 200px)"}}
                pagination={{
                    ...pagination,
                    total: transfersData?.transferReference?.pagination?.total || 0
                }}
                onChange={handleTableChange}
            >
                <Table.Column
                    title="Tarih"
                    dataIndex="createdAt"
                    key="createdAt"
                    render={createdAt =>
                        createdAt ? moment(createdAt).format("DD/MM/YYYY HH:mm") : "-"
                    }
                />
                <Table.Column
                    title="Grup Bilgisi"
                    dataIndex="transferGroups"
                    key="transferGroups"
                    width="300px"
                    render={transferGroups => (
                        <Tooltip title={transferGroups?.map(group => group.name).join(", ") || "-"}>
                            <div
                                style={{
                                    whiteSpace: "nowrap",
                                    maxWidth: "300px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                }}
                            >
                                {transferGroups?.map(group => group.name).join(", ") || "-"}
                            </div>
                        </Tooltip>
                    )}
                />
                <Table.Column
                    title="Teslimat Sayısı"
                    dataIndex="shipmentCount"
                    key="shipmentCount"
                    render={shipmentCount => <span>{shipmentCount || 0} Teslimat</span>}
                />
                <Table.Column
                    title="Paket Sayısı"
                    dataIndex="totalPackageCount"
                    key="totalPackageCount"
                    render={totalPackageCount => <span>{totalPackageCount || 0} Paket</span>}
                />{" "}
                <Table.Column
                    title="Teslim Alınan Paket Sayısı"
                    dataIndex="receivedCount"
                    key="receivedCount"
                    render={receivedCount => <span>{receivedCount || 0} Paket</span>}
                />{" "}
                <Table.Column
                    title="Kayıp Paket Sayısı"
                    dataIndex="missingCount"
                    key="missingCount"
                    render={missingCount => <span>{missingCount || 0} Paket</span>}
                />
                <Table.Column
                    title="Aksiyon"
                    dataIndex="action"
                    key="action"
                    render={(_, record) => {
                        return (
                            <CustomButton
                                onClick={() => getCompletedTransferDetail(record)}
                                loading={loading === record._id}
                            >
                                Detayları Gör
                            </CustomButton>
                        );
                    }}
                />
            </Table>
            {completedTransferDetail && (
                <CompletedTransferDetail
                    open={detailModal}
                    setOpen={setDetailModal}
                    completedTransferDetail={completedTransferDetail}
                    selectedRecord={selectedRecord}
                    setIsModalOpen={setIsModalOpen}
                />
            )}
        </>
    );
};

export default CompletedTransfers;
